export const removeNonDigitChars = (v, unsigned = false) => {
  const isNegative = v.startsWith('-') && !unsigned;
  const sliced = isNegative ? v.slice(1) : v;
  const stripped = sliced.replace(/\D/g, '');
  const result = isNegative ? `-${stripped}` : stripped;

  return result;
};

const isZero = v => v === '0' || v === 0;

const numberOrEmpty = v => (isZero(v) ? 0 : Number(v) || '');

export const turnInputIntoInteger = (v, unsigned = false) => {
  if ((v === '-' && !unsigned) || v === '') {
    return v;
  }
  const strValue = String(v);
  const isNegative = strValue.startsWith('-') && !unsigned;
  const sliced = isNegative ? strValue.slice(1) : strValue;
  const stripped = removeNonDigitChars(sliced, unsigned);
  const signed = isNegative ? `-${stripped}` : stripped;
  const result = numberOrEmpty(signed);

  return result;
};

/**
 * Below code does the same thing but limits us to `MAX_SAFE_INTEGER`
 * ```js
 * Number(input).toLocaleString('en', { useGrouping: true });
 * ```
 *
 * Handles negative numbers as well
 *
 * @returns '1234' | 1234 => '1,234'
 */
export const group = number => {
  const strValue = String(number);
  const isNegative = strValue.startsWith('-');
  const sliced = isNegative ? strValue.slice(1) : strValue;
  const grouped = sliced.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const result = isNegative ? `-${grouped}` : grouped;

  return result;
};
